export enum Experiment {
  /**
   * This experiment is used to switch out the primary CTA on the product hero
   */
  PRODUCT_HERO_CTA = "product-hero-cta",
  /**
   * This experiment is used to switch out any "Get Started" buttons
   * with one that triggers the new "Get Started" modal
   */
  GET_STARTED_MODAL = "get-started-modal",
  /**
   * This experiment is used to display a product rating in the product info section
   */
  PRODUCT_RATING = "product-rating",
  /**
   * This experiment is used to switch out current productInfoSection and solutionInfoSection gallery with updated gallery
   */
  UPDATED_PRODUCT_GALLERY = "updated-product-gallery",
  /**
   * Replace current link behaviour with links to product/purchase pages on `/za/shop`
   */
  SHOP_HERO_PDP = "shop-hero-pdp",
  /**
   * This experiment is used to display a reminder banner
   */
  REMINDER_BANNER = "reminder-banner",
  /**
   * This experiment is used to display the sitewide banner with updated copy
   */
  UPDATED_SITEWIDE_BANNER = "updated-sitewide-banner",
  /**
   * This experiment is used to remove the sitewide banner
   */
  REMOVE_SITEWIDE_BANNER = "remove-sitewide-banner",
  /**
   * This experiment add the content highlight cta to the navigation
   */
  CONTENT_HIGHLIGHT_CTA = "navigation-content-highlight-cta",
  /**
   * This experiment adds a save a step nav to the navigation
   */
  SAVE_A_STEP = "navigation-save-a-step",
  /**
   * This experiment is used to display the product bordered hero with an image background
   */
  BORDERED_HERO_BACKGROUND_IMAGE = "bordered-hero-background-image",
}

interface Rating {
  rating: number
  numReviews: number
}
export const EXPERIMENT_PRODUCT_RATINGS: {
  [sku: string]: Rating
} = {
  KOZP5: {
    //Khumo
    rating: 4.8,
    numReviews: 721,
  },
  KHUMO_PRINT_AND_STAND: {
    //Khumo print and stand bundle
    rating: 4.8,
    numReviews: 158,
  },
  KOZP12B: {
    //neo touch
    rating: 4.8,
    numReviews: 262,
  },
}
